import { Alert, Divider, Grid } from '@mui/material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { CustomTextAreaNoForm, CustomTextFieldNoForm, TabTextLabel } from '@/shared/components/ui';
import { gridSizeMdLg12, gridSizeMdLg3, gridSizeMdLg4 } from '@/shared';

export type AuditViewModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    form: any;
};

const AuditViewModal: React.FC<AuditViewModalProps> = ({
    open,
    setOpen,
    form,
}) => {
    //* handlers
    const handleClose = () => {
        setOpen(false);
    };

    const formatLocalTime = (date: Date | string | null) => {
        if (!date) return null;
        const d = new Date(date);
        if (isNaN(d.getTime())) return null;
        const pad = (value: number) => String(value).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    };

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title={"Revisión de Auditoria"}
                width="100%"
                contentNode={
                    <>
                        {form.idAuditReview ?
                            <>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <TabTextLabel
                                            text={"INFORMACIÓN PRIMERA JORNADA LABORAL"}
                                            mt={0}
                                            pb={2}
                                            pl={0}
                                            pt={2}
                                        />
                                    </Grid>

                                    <CustomTextFieldNoForm
                                        label="Inicio de la jornada"
                                        size={gridSizeMdLg3}
                                        value={form.startTimeOrder || ''}
                                        disabled={true}
                                    />
                                    <CustomTextFieldNoForm
                                        label="Fin de la jornada"
                                        size={gridSizeMdLg3}
                                        value={form.endTimeOrder || ''}
                                        disabled={true}
                                    />

                                    <CustomTextFieldNoForm
                                        label="Tiempo Almuerzo"
                                        value={form.lunchTime || ''}
                                        size={gridSizeMdLg3}
                                        disabled={true}
                                    />
                                    <CustomTextFieldNoForm
                                        label="Horas Extras"
                                        value={form.overtime || ''}
                                        size={gridSizeMdLg3}
                                        disabled={true}
                                    />


                                    <Grid item xs={12}>
                                        <TabTextLabel
                                            text={"INFORMACIÓN SEGUNDA JORNADA LABORAL (OPCIONAL)"}
                                            mt={0}
                                            pb={2}
                                            pl={0}
                                            pt={2}
                                        />
                                    </Grid>

                                    <CustomTextFieldNoForm
                                        label="Inicio de la jornada"
                                        size={gridSizeMdLg3}
                                        value={form.startTimeOrder2 || ''}
                                        disabled={true}
                                    />
                                    <CustomTextFieldNoForm
                                        label="Fin de la jornada"
                                        size={gridSizeMdLg3}
                                        value={form.endTimeOrder2 || ''}
                                        disabled={true}
                                    />

                                    <CustomTextFieldNoForm
                                        label="Tiempo Almuerzo"
                                        value={form.lunchTime2 || ''}
                                        size={gridSizeMdLg3}
                                        disabled={true}
                                    />
                                    <CustomTextFieldNoForm
                                        label="Horas Extras"
                                        value={form.overtime2 || ''}
                                        size={gridSizeMdLg3}
                                        disabled={true}
                                    />

                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 4 }} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <CustomTextAreaNoForm
                                        label="Detalle una observación de la auditoria"
                                        size={gridSizeMdLg12}
                                        value={form.detailReportAuditReview || ''}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 4 }} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <CustomTextFieldNoForm
                                        label="Usuario Auditoria"
                                        value={form.userRegister || ''}
                                        size={gridSizeMdLg3}
                                        disabled={true}
                                    />
                                    <CustomTextFieldNoForm
                                        label="Fecha de Registro Auditoria"
                                        value={form.registrationDate ? formatLocalTime(form.registrationDate)?.toString() : ''}
                                        size={gridSizeMdLg4}
                                        disabled={true}
                                    />
                                </Grid>
                            </>
                            :
                            <>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <Alert
                                            severity="warning"
                                            variant="outlined"
                                            color='warning'
                                        >
                                            La orden de trabajo no registra auditorias ingresadas
                                        </Alert>
                                    </Grid>
                                </Grid>
                            </>
                        }
                    </>
                }
                onClose={handleClose}
            />
        </>
    );
};

export default AuditViewModal;
